import { styled, Typography } from '@mui/material'

export const MostReadCardContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  cursor: 'pointer',
}))

export const ImageContainer = styled('div')(() => ({
  width: '95px',
  height: '95px',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '4px',
  flexShrink: 0,
}))

export const PositionContainer = styled(Typography)(({ theme }) => ({
  ...theme.typography.button,
  position: 'absolute',
  top: 0,
  left: 0,
  width: '32px',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0, 0, 0, 0.35)',
  backdropFilter: 'blur(7.5px)',
  borderRadius: '4px 0 4px 0',
}))

export const CategoryTitleAndDateContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))
